<template>
  <div>
    <div>
      <div class="row align-items-center">
        <div class="col col-11">
          <div class="card-header border-0">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label page-title fw-bolder fs-3 mb-1"
                >Customers</span
              >
            </h3>
          </div>
        </div>
        <div class="col">
          <button type="button" @click="initalGetCustomers()">
            <i class="fas fa-redo fa-2x"></i>
          </button>
        </div>
      </div>

      <input
        type="text"
        class="form-control form-control-lg form-control-solid px-15"
        v-model="search"
        placeholder="Search by Customer Name, Status, PYB#"
        data-kt-search-element="input"
      />
      <!--end::Input-->
    </div>

    <div class="spacer-y-10"></div>

    <!--begin::Table container-->
    <v-data-table
      :headers="tableHeaders"
      :items="searchResults"
      item-key="pybNumber"
      class="elevation-1"
      :loading="loadingList"
      loading-text="Loading Customers..."
      :page.sync="currentPage"
      @page-count="pageCount = $event"
      :sort-by="sort.by"
      :sort-desc="sort.desc"
    >
      <template v-slot:[`item.pybNumber`]="{ item }">
        <router-link
          :to="{
            name: 'ViewCustomer',
            params: { pybNumber: item.pybNumber },
          }"
          >{{ item.pybNumber }}</router-link
        >
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div v-if="item.status != 'Confirmed'">
          <button
            type="button"
            class="resend-email-btn"
            @click="resendWelcomeEmail(item.pybNumber)"
          >
            Resend Password
          </button>
        </div>
      </template>

      <template v-slot:[`item.signUpDate`]="{ item }">
        {{ formatDate(item.signUpDate) }}
      </template>

      <template v-slot:[`item.delete`]="{ item }">
        <button
                type="button"
                class="delete-customer-btn"
                @click="deleteCustomer(item.pybNumber)"
              >
                Delete Customer
        </button>
      </template>
    </v-data-table>
    <!--end::Table-->
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />

    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="confirmationAccept"
      @eCancel="confirmationReject"
    />
  </div>
</template>

<script>
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";

import dayjs from "dayjs";

export default {
  name: "ManageCustomers",
  components: { SnackbarNotifier,ConfirmationModal },
  mixins: [SnackbarNotifierMixin, ConfirmationModalMixin],
  data() {
    return {
      loadingList: false,
      search: "",
      limit: 3000,
      pullLimit: 1000,
      startKey: null,
      customers: [],
      pageCount: 0,
      currentPage: 1,
      sort: {
        by: ["signUpDate"],
        desc: [true],
      },
      tableHeaders: [
        {
          text: "PYB #",
          value: "pybNumber",
        },
        { text: "Name", value: "fullName" },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Status", value: "status" },
        { text: "Sign Up", value: "signUpDate", width: 100 },
        { text: "Action", value: "action", width: 170 },
        { text: "Delete", value: "delete", width: 170 }
      ],
    };
  },
  computed: {
    searchResults() {
      if (!this.search) return this.customers;

      return this.customers.filter((c) => {
        return (
          c.pybNumber.includes(this.search.toLowerCase()) ||
          c.fullName.toLowerCase().includes(this.search.toLowerCase()) ||
          c.phone.includes(this.search) ||
          c.status.toLowerCase().includes(this.search.toLowerCase()) ||
          this.formatDate(c.signUpDate)
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          c.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    isLastPage() {
      if (this.pageCount < 1) {
        return false;
      }

      return this.currentPage >= this.pageCount;
    },
  },
  watch: {
    isLastPage(newValue) {
      if (!newValue) {
        return;
      }
      this.loadMoreData();
    },
  },
  methods: {
    async resendWelcomeEmail(pybNumber) {
      try {
        await ApiService.Instance.resendWelcomeEmail({ pybNumber });
        this.showNotifier({
          message: `Password Sent`,
          snackbarType: "success",
        });
      } catch (error) {
        error(error);
        this.showNotifier({
          message: `Failed to send password`,
          snackbarType: "error",
        });
      }
    },
    async deleteCustomer(pybNumber) {
      try {


        const shouldDeleteCustomer = await this.confirm();
        this.stopConfirmationLoading();
        if (!shouldDeleteCustomer) {
          return;
        }
        this.loading = true;

        await ApiService.Instance.deleteCustomer({
          pybNumber: pybNumber,
        });

        this.showNotifier({
          message: `Deleted Customer`,
          snackbarType: "success",
        });

        const index = this.customers.findIndex(customers => customers.pybNumber === pybNumber);
        this.customers.splice(index, 1);



      } catch (e) {
        error(e);
        this.showNotifier({
          message: `Failed To Delete Customer`,
          snackbarType: "error",
        });
      }
      this.loading = false;
    },
    formatDate(date) {
      try {
        return dayjs(date).format("DD-MMM-YY");
      } catch {}
      return "";
    },
    async loadMoreData() {
      if (!this.startKey) {
        return;
      }

      await this.getCustomers(this.startKey);
    },
    async initalGetCustomers() {
      this.customers = [];
      this.startKey = null;
      await this.getCustomers();
    },
    async getCustomers(startKey) {
      try {
        do {
          this.loadingList = true;
          const result = await ApiService.Instance.getAllCustomers({
            headers: {
              startKey,
              limit: this.limit,
            },
          });

          if (!!result.data) {
            this.customers.push(...result.data);
          }

          startKey = result.lastEvaluatedKey;
          this.startKey = result.lastEvaluatedKey;
        } while (this.customers < this.pullLimit && !!this.startKey);
      } catch (e) {
        error(e);
      }
      this.loadingList = false;
    },
  },
  async beforeMount() {
    await this.initalGetCustomers();
  },
};
</script>

<style lang="scss" scoped>
.resend-email-btn {
  color: #4848ff;
}

.delete-customer-btn {
  color: red;
}
</style>